module.exports = __webpack_public_path__ + "img/hezuo.788f2c5a.png";